export const industrySolutions = [
  {
    icon: 'ri-bowl-line',
    name: '食品',
    pain: 'SKU繁多、渠道复杂、动销难追踪',
  },
  {
    icon: 'ri-cup-line',
    name: '饮料',
    pain: '渠道层级多、终端覆盖难、促销费用难追踪',
  },
  {
    icon: 'ri-drop-line',
    name: '日化个护',
    pain: '促销频繁、核销周期长、陈列达标难监控',
  },
  {
    icon: 'ri-restaurant-line',
    name: '调味品',
    pain: '消费者互动缺失、渠道数据割裂、复购驱动力不足',
  },
  {
    icon: 'ri-goblet-line',
    name: '啤酒',
    pain: '旺季资源投放不精准、终端动销数据滞后',
  },
  {
    icon: 'ri-cake-3-line',
    name: '乳制品',
    pain: '库存积压风险高、终端数据获取慢',
  },
];

export const painSolutions = [
  {
    num: '01',
    title: '营销费用不透明',
    desc: '从预算申请到核销复盘全流程数字化，每一笔费用可追溯至具体门店与活动，费用管控从"黑盒"变"白盒"。',
  },
  {
    num: '02',
    title: '终端执行数据缺失',
    desc: '促销员工具与消费者扫码数据双重采集，构建真实、实时的终端数据体系，动销情况一目了然。',
  },
  {
    num: '03',
    title: '消费者互动不足',
    desc: '扫码激励、积分运营、个性化活动三重机制，将一次性购买转化为持续复购，品牌黏性持续增强。',
  },
  {
    num: '04',
    title: '渠道库存不清楚',
    desc: '终端与渠道库存数据断层，无法实时掌握各级库存水位，导致断货与积压并存，资金周转效率低。',
  },
  {
    num: '05',
    title: '窜货乱价',
    desc: '跨区域窜货、线上线下价格冲突频发，扰乱市场秩序，损害品牌形象与经销商利益，管控无从下手。',
  },
];